import { render, staticRenderFns } from "./AssetTypePage.vue?vue&type=template&id=52cfcbed&scoped=true&"
import script from "./AssetTypePage.vue?vue&type=script&lang=ts&"
export * from "./AssetTypePage.vue?vue&type=script&lang=ts&"
import style0 from "./AssetTypePage.vue?vue&type=style&index=0&id=52cfcbed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cfcbed",
  null
  
)

export default component.exports